import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

const HighEfficiencyBestCloud = () => {
    const { t } = useTranslation(["common", "cloudServer"]);
    const [activeSection, setActiveSection] = useState("virtual-server");
    const contentRef = useRef(null);
    const itemRefs = useRef([]);

    const sections = [
        {
            id: "virtual-server",
            title: t("cloudServer:cloudServerDifferencesCloudStorage"),
            desc: t("cloudServer:cloudServerDifferencesCloudStorageDesc"),
            desc2: t("cloudServer:cloudServerDifferencesCloudStorageDesc2"),
            desc3: t("cloudServer:cloudServerDifferencesCloudStorageDesc3"),
        },
        {
            id: "used-for",
            title: t("cloudServer:ssdBasedFastStorage"),
            desc: t("cloudServer:ssdBasedFastStorageDesc"),
            desc2: t("cloudServer:ssdBasedFastStorageDesc2"),
            desc3: t("cloudServer:ssdBasedFastStorageDesc3"),
            desc4: t("cloudServer:ssdBasedFastStorageDesc4"),
        },
        {
            id: "advantages",
            title: t("cloudServer:dataBackupAndSecurityMeasures"),
            desc: t("cloudServer:dataBackupAndSecurityMeasuresDesc"),
            desc2: t("cloudServer:dataBackupAndSecurityMeasuresDesc2"),
            desc3: t("cloudServer:dataBackupAndSecurityMeasuresDesc3"),
            desc4: t("cloudServer:dataBackupAndSecurityMeasuresDesc4"),
        }
    ];

    const handleClick = (id) => {

        const contentBox = contentRef.current; // Container referansı
        const element = document.getElementById(id); // Hedef eleman

        if (element && contentBox) {
            // Elemanın container'a göre top pozisyonunu hesapla
            const elementTop = element.getBoundingClientRect().top - contentBox.getBoundingClientRect().top;

            // Container'ın mevcut scrollTop değerine elemanın pozisyonunu ekle
            const scrollTopValue = contentBox.scrollTop + elementTop - 7;

            // Container içinde scroll yap
            contentBox.scrollTo({
                top: scrollTopValue, // Tam hizalama için hesaplanan değer
                behavior: "smooth",
            });
        }
    };

    const handleScroll = () => {
        if (!contentRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        // Scroll pozisyonunu kontrol et
        const contentTop = contentRef.current.getBoundingClientRect().top;

        // Her bir öğenin pozisyonunu kontrol et
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            setActiveSection(sections[sections.length - 1].id);
            return;
        }
        else {
            for (let i = itemRefs.current.length - 1; i >= 0; i--) {
                const ref = itemRefs.current[i];
                if (ref) {
                    const rect = ref.getBoundingClientRect();

                    // Eğer öğenin üst kısmı container'ın üst kısmından daha yukarıdaysa, o öğeyi aktif yap
                    if (rect.top < contentTop + 200) {
                        setActiveSection(sections[i].id);
                        return;
                    }
                }
            }
        }
        // Eğer hiçbir şey eşleşmezse, ilk öğeyi aktif yap
        setActiveSection(sections[0].id);
    };

    useEffect(() => {
        const container = contentRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            handleScroll(); // İlk yüklemede çalıştır
            return () => container.removeEventListener("scroll", handleScroll);
        }
    }, [sections]);

    return (
        <div className="bg-buttonBg">
            <div className="container px-4 py-5 mx-auto lg:py-10 ">
                <h2 className="relative z-10 text-3xl font-bold text-center lg:text-4xl text-titleColor text-after-shadow-cloud3">{t("cloudServer:highEfficiencyBestCloud")}</h2>
                <div className="pt-8 text-textGray" dangerouslySetInnerHTML={{ __html: t("cloudServer:highEfficiencyBestCloudDesc") }}></div>

                <div className="grid grid-cols-2 gap-5 lg:gap-10">
                    {/* Sol Menü */}
                    <div className="hidden col-span-2 lg:col-span-1 lg:block">
                        <div className="flex flex-col items-center justify-center mb-4">
                            <Image
                                src={"/cloudServerSolutions.png"}
                                width={557}
                                height={216}
                                alt={t("cloudServer:highEfficiencyBestCloud")}
                                title={t("cloudServer:highEfficiencyBestCloud")}
                            />
                        </div>
                        <ul className="space-y-5">
                            {sections.map((section, index) => (
                                <li
                                    key={index}
                                    onClick={() => section.id != activeSection && handleClick(section.id)}
                                    className={`cursor-pointer text-lg font-semibold ${activeSection === section.id
                                        ? "lg:text-black "
                                        : "lg:text-textGray"
                                        }`}
                                >
                                    • {section.title}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Sağ İçerik */}
                    <div className="lg:mt-24  lg:h-[488px] lg:overflow-y-auto customScroll space-y-8 lg:space-y-16 col-span-2 lg:col-span-1" ref={contentRef}>
                        {sections.map((section, index) => (
                            <div key={section.id} id={section.id} ref={(el) => (itemRefs.current[index] = el)} className={`${activeSection == section.id ? "" : "lg:opacity-25"}  ${sections.length == index + 1 ? "lg:pb-32" : ""} pt-4 lg:pt-0`}>
                                <h3 className={`text-titleColor text-3xl px-1 font-semibold  ${activeSection === section.id ? 'relative z-10 lg:text-after-shadow-cloud4' : ''}`}>{section.title}</h3>
                                <div className="flex items-center space-x-2">
                                    <div className="mt-4 text-textGray" dangerouslySetInnerHTML={{ __html: section.desc }}></div>
                                </div>
                                <p className="mt-4 text-textGray">⚡ {section.desc2}</p>
                                <div className="flex items-center space-x-2">
                                    ⚡ <div className="mt-4 text-textGray" dangerouslySetInnerHTML={{ __html: section.desc3 }}></div>
                                </div>
                                <p className="mt-4 text-textGray">{section.desc4 ? '⚡' + section.desc4 : ''}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HighEfficiencyBestCloud